"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/nb_NO");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternativ tekst:"
  },
  announcement_list_da155734: {
    message: "Kunngj\xF8ringsliste"
  },
  announcements_a4b8ed4a: {
    message: "Kunngj\xF8ringer"
  },
  assignments_1e02582c: {
    message: "Oppgaver"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Bakgrunnsfarge, trykk nedover for \xE5 velge"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Avbryt filopplasting"
  },
  cancel_image_upload_2c771950: {
    message: "Avbryt bildeopplasting"
  },
  cc_attribution_f6de631f: {
    message: "CC-attribusjon"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC-attribusjon \u2013 Ingen bearbeidelser"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC-attribusjon Ikke-kommersiell"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC-attribusjon Ikke-kommersiell Ingen bearbeidelser"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC-attribusjon Ikke-kommersiell Del p\xE5 samme vilk\xE5r"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC-attribusjon Del p\xE5 samme vilk\xE5r"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Sjekk om bildet er dekorativt"
  },
  choose_usage_rights_33683854: {
    message: "Velg bruksrettigheter..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Klikk p\xE5 en fil for \xE5 sette inn en nedlastingslenke til filen."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Klikk p\xE5 et bilde for \xE5 bygge inn bildet p\xE5 siden."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Klikk p\xE5 en side for \xE5 sette inn en lenke til den siden."
  },
  click_to_embed_image_33107dd8: {
    message: "Klikk for \xE5 bygge inn bilde"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Klikk for \xE5 bygge inn { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Klikk for \xE5 sette inn en kobling i redigeringsprogrammet."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Klikk for \xE5 sette inn en kobling i dette elementet."
  },
  close_flickr_form_b32e600a: {
    message: "Lukk Flickr-skjema"
  },
  collaborations_5c56c15f: {
    message: "Samarbeid"
  },
  copyright_holder_66ee111: {
    message: "Rettighetshaver:"
  },
  course_navigation_dd035109: {
    message: "Emnenavigering"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons-lisens:"
  },
  decorative_image_fde98579: {
    message: "Dekorativt bilde"
  },
  discussions_a5f96392: {
    message: "Diskusjoner"
  },
  discussions_index_6c36ced: {
    message: "Diskusjonsindeks"
  },
  embed_image_1080badc: {
    message: "Sett inn bilde"
  },
  enter_search_terms_e397b1f0: {
    message: "skriv inn s\xF8keord"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Skriv inn alternativteksten for dette bildet"
  },
  file_upload_form_4aaad554: {
    message: "Filopplastningsskjema"
  },
  files_c300e900: {
    message: "Filer"
  },
  files_index_af7c662b: {
    message: "Filindeks"
  },
  folder_705fd2d7: {
    message: "Mappe"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Skriftst\xF8rrelse, trykk nedover for \xE5 velge"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formatering, trykk nedover for \xE5 velge"
  },
  grades_a61eba0a: {
    message: "Karakterer"
  },
  group_navigation_99f191a: {
    message: "Gruppenavigering"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Jeg har f\xE5tt tillatelse til \xE5 bruke denne filen."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Jeg har opphavsretten"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Dersom du ikke velger brukerrettigheter n\xE5, vil denne filen v\xE6re upublisert n\xE5r den lastes opp."
  },
  image_upload_form_7b74079a: {
    message: "Bildeopplastningsskjema"
  },
  images_7ce26570: {
    message: "Bilder"
  },
  insert_equella_links_49a8dacd: {
    message: "Sett inn Equella-koblinger"
  },
  insert_link_6dc23cae: {
    message: "Sett inn lenke"
  },
  insert_math_equation_57c6e767: {
    message: "Sett matte likning"
  },
  link_7262adec: {
    message: "Lenke"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Lenke til en ny side"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Lenke til annet innhold i emnet."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Lenke til annet innhold i gruppen."
  },
  link_to_url_52dd935c: {
    message: "Lenke til URL"
  },
  links_14b70841: {
    message: "Lenker"
  },
  load_more_results_460f49a9: {
    message: "Last flere resultater"
  },
  loading_25990131: {
    message: "Laster..."
  },
  loading_failed_b3524381: {
    message: "Lasting mislyktes..."
  },
  loading_folders_8d4d5d5a: {
    message: "Laster mapper..."
  },
  modules_c4325335: {
    message: "Moduler"
  },
  no_results_940393cf: {
    message: "Ingen resultater."
  },
  pages_e5414c2c: {
    message: "Sider"
  },
  people_b4ebb13c: {
    message: "Personer"
  },
  quizzes_7e598f57: {
    message: "Tester"
  },
  record_upload_media_5fdce166: {
    message: "Gj\xF8r opptak/last opp media"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Riktekstomr\xE5de. Trykk ALT+F8 for hjelp"
  },
  search_280d00bd: {
    message: "S\xF8k"
  },
  search_flickr_6884b518: {
    message: "S\xF8k Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Velg en fil"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Velg mappen du vil laste opp filen til"
  },
  syllabus_f191f65b: {
    message: "Emneoversikt"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Tekstfarge, trykk nedover for \xE5 velge"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Materialet er i det offentlige domenet"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Materialet er lisensiert under Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Materialet er underlagt korrekt bruk-unntak"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Opplastingen overskrider kvoten p\xE5 lagringsplassen. Vennligst kontakt systemadministratoren din."
  },
  upload_8b403d05: {
    message: "Last opp"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Last opp en ny fil"
  },
  upload_a_new_image_890df275: {
    message: "Last opp et nytt bilde"
  },
  usage_right_ff96f3e2: {
    message: "Brukerrettigheter:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Hva vil du kalle den nye siden?"
  },
  wiki_home_9cd54d0: {
    message: "Wikiforside"
  }
};

_formatMessage.default.addLocale({
  nb: locale
});